<template>
  <svg
    class="stroke-current"
    stroke-linecap="round"
    stroke-linejoin="round"
    clip-rule="evenodd"
    height="100%"
    width="100%"
    viewBox="0 0 24 24"
  >
    <path fill="none" stroke-width="1.5" d="M5.711 12.004L18.282.997l.007 22.006-12.578-11z" />
  </svg>
</template>

<script>
/*
 !!TODO: Must be reviewed after the MVP has been introduced.
 !!This file should be refactored if necessary.
 *----------------------------------------------------------*
 !!author: Christopher Bomm
*/
export default {}
</script>
